import { base64UrlDecode } from "@/utils/base64-url";
import { CompanyType } from "@/features/types";
import {
  getAccessToken as getAccessTokenCookie,
  getRefreshToken as getRefreshTokenCookie,
  setTokens as setTokenCookies,
  clearTokens as clearTokenCookies,
} from "@/utils/token-cookie";

// 토큰 쿠키의 읽기/쓰기와 만료 정책은 token-cookie.ts가 전담한다.
// 기존 import 경로를 유지하기 위해 여기서 다시 내보낸다.
export const setTokens = setTokenCookies;
export const clearTokens = clearTokenCookies;

export interface JWTScope {
  type: CompanyType;
  id: number;
  to: "ALL";
}

export interface JWTPayload {
  sub: number;
  scopes: JWTScope[];
  iat: Date;
  exp: Date;
}

export function getJwtPayload(): JWTPayload | undefined {
  const accessToken = getAccessToken();
  if (accessToken) {
    try {
      const obj = JSON.parse(base64UrlDecode(accessToken.split(".")[1]));
      const { scopes, iat, exp, ...rest } = obj;
      const inflatedScopes = scopes.map((s: string) => {
        const [type, rawId, to] = s.split(":");
        return { type, id: parseInt(rawId), to };
      });

      return {
        ...rest,
        scopes: inflatedScopes,
        iat: new Date(parseInt(iat) * 1000),
        exp: new Date(parseInt(exp) * 1000),
      };
    } catch (e) {
      clearTokens();
    }
  }
}

export function getAccessToken() {
  return getAccessTokenCookie();
}

export function getRefreshToken() {
  return getRefreshTokenCookie();
}
